import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Form, InputGroup } from "react-bootstrap";
import moment from "moment";
import { DatePicker } from "antd";
import SearchSelect from "components/common/SearchSelect";
import { closeCustomModal, openCustomModal } from "components/custom/modals";
import {
    getEmploymentTypeItems,
    getEmploymentStatusItems,
    getLanguagesItems,
    getAppliedFor,
    getHoursOfWorkAvailability,
} from "actions/systemListsActions";
import {
    resetPassword
} from "api/menu/master-files/workers-maintenance/actions";

const EditPasswordModal =
    React.lazy(() => import("components/menu/master-files/workers-maintenance/worker-profile-components/edit-password-modal"));

class TabWorkerProfileInfo extends React.Component {
    constructor(props) {
        super(props);

        this.getUserLanguage = this.getUserLanguage.bind(this);
        this.handleResetPassword = this.handleResetPassword.bind(this);

        const { isEditable } = this.props;

        if (isEditable) {
            this.props.getEmploymentTypeItems();
            this.props.getEmploymentStatusItems();
            this.props.getLanguagesItems();
            this.props.getAppliedFor();
            this.props.getHoursOfWorkAvailability();
        }
    }

    getUserLanguage = (language, isSpoken) => {
        let workerLanguages = this.props.getEmployeeValue("languages", this.props.tabKey);
        workerLanguages = Array.isArray(workerLanguages) ? workerLanguages : [];

        const workerCurrentLanguage = workerLanguages
            .filter(item => item.languageId === language.id);
        if (!workerCurrentLanguage || !workerCurrentLanguage.length) {
            return false;
        }

        if (isSpoken) {
            return workerCurrentLanguage[0].isSpoken;
        }
        return workerCurrentLanguage[0].isWritten;
    };

    handleResetPassword = () => {
        const modalObj = {
            id: "change-worker-password",
            header: "Change Password",
            modalSettings: {
                size: "sm"
            },
            children: (
                <React.Suspense fallback={<div className="m-2 text-center font-weight-bold">Loading...</div>}>
                    <EditPasswordModal
                        onCancel={() => this.props.closeCustomModal(modalObj)}
                        onSubmit={(password) => {
                            this.props.resetPassword(this.props.workerId, password);
                            this.props.closeCustomModal(modalObj);
                        }}
                    />
                </React.Suspense>
            ),
            handleClose: () => this.props.closeCustomModal(modalObj)
        };
        this.props.openCustomModal(modalObj);
    };

    render() {
        const {
            isEditable,
            employmentTypes,
            employmentStatus,
            languages,
            appliedFor,
            workHoursAvailability
        } = this.props;

        const employmentTypeOptions = employmentTypes ? employmentTypes.map(item => ({
            value: item.id,
            label: item.value
        })) : [];
        const employmentTypeId = this.props.getEmployeeValue("employmentTypeId", this.props.tabKey);
        const currentEmploymentType = employmentTypeId
            ? employmentTypeOptions.find(item => item.value === employmentTypeId)
            : null;

        const employmentStatusOptions = employmentStatus ? employmentStatus.map(item => ({
            value: item.id,
            label: item.value
        })) : [];
        const employmentStatusId = this.props.getEmployeeValue("employmentStatusId", this.props.tabKey);
        const currentEmploymentStatus = employmentStatusId
            ? employmentStatusOptions.find(item => item.value === employmentStatusId)
            : null;

        const workHoursAvailabilityOptions = workHoursAvailability
            ? workHoursAvailability.map(item => ({
                value: item.id,
                label: item.value
            }))
            : [];
        const hoursAvailableId = this.props.getEmployeeValue("hoursAvailableId", this.props.tabKey);
        const currentWorkHoursAvailability = hoursAvailableId
            ? workHoursAvailabilityOptions.find(item => item.value === hoursAvailableId)
            : null;

        let positionsApplied = this.props.getEmployeeValue("positionsApplied", this.props.tabKey);
        if (!positionsApplied || !Array.isArray(positionsApplied)) {
            positionsApplied = [];
        }

        return (
            <div className="container mt-3">
                <div className="row">
                    <div className="col-6">
                        <Form.Group className="d-flex justify-content-end align-items-baseline">
                            <Form.Label className="col-6 text-right mr-2">
                                Employment Type
                            </Form.Label>
                            {isEditable ?
                                <div className="p-0 col-6">
                                    <SearchSelect
                                        className="custom-react-select g-filter-select-no-padding"
                                        options={employmentTypeOptions}
                                        isClearable={false}
                                        isMulti={false}
                                        isLoading={false}
                                        value={currentEmploymentType}
                                        onChange={item => {
                                            this.props.onChange([{
                                                name: "employmentType",
                                                value: item ? item.label : null
                                            }, {
                                                name: "employmentTypeId",
                                                value: item ? item.value : null
                                            }], this.props.tabKey);
                                        }}
                                        isDisabled={!isEditable}
                                    />
                                </div>
                                :
                                <Form.Control
                                    type="text"
                                    className="col-6"
                                    readOnly={true}
                                    defaultValue={this.props.getEmployeeValue("employmentType", this.props.tabKey)}
                                />
                            }
                        </Form.Group>
                    </div>
                    <div className="col-6">
                        <div className="row">
                            <div className="col-4 pl-0">
                                <InputGroup>
                                    <InputGroup.Prepend>
                                        <InputGroup.Text>Bank #</InputGroup.Text>
                                    </InputGroup.Prepend>
                                    <Form.Control
                                        type="text"
                                        readOnly={!isEditable}
                                        name="bank"
                                        className="form-control-sm"
                                        value={this.props.getEmployeeValue("bank", this.props.tabKey) || ""}
                                        onChange={(ev) =>
                                            this.props.onChange(ev, this.props.tabKey)}
                                    />
                                </InputGroup>
                            </div>
                            <div className="col-4 pl-0">
                                <InputGroup>
                                    <InputGroup.Prepend>
                                        <InputGroup.Text>Transit #</InputGroup.Text>
                                    </InputGroup.Prepend>
                                    <Form.Control
                                        type="text"
                                        readOnly={!isEditable}
                                        name="transit"
                                        className="form-control-sm"
                                        value={this.props.getEmployeeValue("transit", this.props.tabKey) || ""}
                                        onChange={(ev) =>
                                            this.props.onChange(ev, this.props.tabKey)}
                                    />
                                </InputGroup>
                            </div>
                            <div className="col-4 pl-0">
                                <InputGroup>
                                    <InputGroup.Prepend>
                                        <InputGroup.Text>Account #</InputGroup.Text>
                                    </InputGroup.Prepend>
                                    <Form.Control
                                        type="text"
                                        readOnly={!isEditable}
                                        name="account"
                                        className="form-control-sm"
                                        value={this.props.getEmployeeValue("account", this.props.tabKey) || ""}
                                        onChange={(ev) =>
                                            this.props.onChange(ev, this.props.tabKey)}
                                    />
                                </InputGroup>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-6">
                        <Form.Group className="d-flex justify-content-end align-items-baseline">
                            <Form.Label className="col-6 text-right mr-2">
                                Employment Status
                            </Form.Label>
                            {isEditable ?
                                <div className="p-0 col-6">
                                    <SearchSelect
                                        className="custom-react-select g-filter-select-no-padding"
                                        options={employmentStatusOptions}
                                        isClearable={false}
                                        isMulti={false}
                                        isLoading={false}
                                        value={currentEmploymentStatus}
                                        onChange={item => {
                                            this.props.onChange([{
                                                name: "employmentStatus",
                                                value: item ? item.label : null
                                            }, {
                                                name: "employmentStatusId",
                                                value: item ? item.value : null
                                            }], this.props.tabKey);
                                        }}
                                        isDisabled={!isEditable}
                                    />
                                </div>
                                :
                                <Form.Control
                                    type="text"
                                    className="col-6"
                                    readOnly={true}
                                    defaultValue={this.props.getEmployeeValue("employmentStatus", this.props.tabKey)}
                                />
                            }
                        </Form.Group>
                    </div>
                    <div className="col-6">
                        <Form.Group className="d-flex justify-content-end align-items-baseline">
                            <Form.Label className="col-6 text-right mr-2">
                                Helper Info.
                            </Form.Label>
                            <Form.Control
                                type="text"
                                readOnly={!isEditable}
                                className="col-6"
                                name="helperInfo"
                                value={this.props.getEmployeeValue("helperInfo", this.props.tabKey) || ""}
                                onChange={(ev) => this.props.onChange(ev, this.props.tabKey)}
                            />
                        </Form.Group>
                    </div>
                </div>
                <div className="row">
                    <div className="col-6">
                        <Form.Group className="d-flex justify-content-end align-items-baseline">
                            <Form.Label className="col-6 text-right mr-2">
                                Resume Entered On
                            </Form.Label>
                            {isEditable ?
                                <DatePicker
                                    value={this.props.getEmployeeValue("resumeEnteredDate", this.props.tabKey) !== ""
                                    && this.props.getEmployeeValue("resumeEnteredDate", this.props.tabKey) !== null
                                        ? moment(this.props.getEmployeeValue("resumeEnteredDate", this.props.tabKey))
                                        : null}
                                    format="YYYY-MM-DD"
                                    name="resumeEnteredDate"
                                    onChange={(date) => {
                                        this.props.onChange({
                                            target: {
                                                name: "resumeEnteredDate",
                                                value: date ? moment(date).format("YYYY-MM-DD") : null,
                                                type: "date"
                                            }
                                        }, this.props.tabKey);
                                    }}
                                    className="d-block col-6"
                                />
                                :
                                <Form.Control
                                    type="text"
                                    className="col-6"
                                    readOnly={true}
                                    defaultValue={this.props.getEmployeeValue("resumeEnteredDate", this.props.tabKey) !== ""
                                    && this.props.getEmployeeValue("resumeEnteredDate", this.props.tabKey) !== null
                                        ? moment(this.props.getEmployeeValue("resumeEnteredDate", this.props.tabKey)).format("YYYY-MM-DD")
                                        : ""}
                                />
                            }
                        </Form.Group>
                    </div>
                    <div className="col-4 offset-2">
                        <Form.Check
                            type="checkbox"
                            label="Contract Signed"
                            checked={this.props.getEmployeeValue(
                                "contractSigned",
                                this.props.tabKey
                            )}
                            readOnly={!isEditable}
                            name="isMerchandiser"
                            onChange={() => {
                                if (!isEditable) {
                                    return;
                                }
                                this.props.onChange({
                                    target: {
                                        name: "contractSigned",
                                        value: !this.props.getEmployeeValue("contractSigned", this.props.tabKey)
                                    }
                                }, this.props.tabKey);
                            }}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-6">
                        <Form.Group className="d-flex justify-content-end align-items-baseline">
                            <Form.Label className="col-6 text-right mr-2">
                                Last Date Worked
                            </Form.Label>
                            {isEditable ?
                                <DatePicker
                                    value={this.props.getEmployeeValue("lastWorkedDate", this.props.tabKey) !== ""
                                    && this.props.getEmployeeValue("lastWorkedDate", this.props.tabKey) !== null
                                        ? moment(this.props.getEmployeeValue("lastWorkedDate", this.props.tabKey))
                                        : null}
                                    format="YYYY-MM-DD"
                                    name="lastWorkedDate"
                                    onChange={(date) => {
                                        this.props.onChange({
                                            target: {
                                                name: "lastWorkedDate",
                                                value: date ? moment(date).format("YYYY-MM-DD") : null,
                                                type: "date"
                                            }
                                        }, this.props.tabKey);
                                    }}
                                    className="d-block col-6"
                                    disabled={!isEditable}
                                />
                                :
                                <Form.Control
                                    type="text"
                                    className="col-6"
                                    readOnly={true}
                                    defaultValue={this.props.getEmployeeValue("lastWorkedDate", this.props.tabKey) !== ""
                                    && this.props.getEmployeeValue("lastWorkedDate", this.props.tabKey) !== null
                                        ? moment(this.props.getEmployeeValue("lastWorkedDate", this.props.tabKey).format("YYYY-MM-DD"))
                                        : ""}
                                />
                            }
                        </Form.Group>
                    </div>
                    <div className="col-4 offset-2">
                        <Form.Check
                            type="checkbox"
                            label="Sub-Contract Signed"
                            checked={this.props.getEmployeeValue(
                                "subContractSigned",
                                this.props.tabKey
                            )}
                            readOnly={!isEditable}
                            name="subContractSigned"
                            onChange={() => {
                                if (!isEditable) {
                                    return;
                                }
                                this.props.onChange({
                                    target: {
                                        name: "subContractSigned",
                                        value: !this.props.getEmployeeValue("subContractSigned", this.props.tabKey)
                                    }
                                }, this.props.tabKey);
                            }}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-6">
                        <Form.Group className="d-flex justify-content-end align-items-baseline">
                            <Form.Label className="col-6 text-right mr-2">
                                Hours of Work Avail.
                            </Form.Label>
                            {isEditable ?
                                <div className="p-0 col-6">
                                    <SearchSelect
                                        className="custom-react-select g-filter-select-no-padding"
                                        options={workHoursAvailabilityOptions}
                                        isClearable={false}
                                        isMulti={false}
                                        isLoading={false}
                                        value={currentWorkHoursAvailability}
                                        onChange={item => {
                                            this.props.onChange([{
                                                name: "hoursAvailable",
                                                value: item ? item.label : null
                                            }, {
                                                name: "hoursAvailableId",
                                                value: item ? item.value : null
                                            }], this.props.tabKey);
                                        }}
                                        isDisabled={!isEditable}
                                    />
                                </div>
                                :
                                <Form.Control
                                    type="text"
                                    readOnly
                                    className="col-6"
                                    name="hoursAvailable"
                                    value={this.props.getEmployeeValue("hoursAvailable", this.props.tabKey) || ""}
                                />
                            }
                        </Form.Group>
                    </div>
                    <div className="col-4 offset-2">
                        <Form.Check
                            type="checkbox"
                            label="Policy Discussed"
                            checked={this.props.getEmployeeValue(
                                "policyDiscussed",
                                this.props.tabKey
                            )}
                            readOnly={!isEditable}
                            name="policyDiscussed"
                            onChange={() => {
                                if (!isEditable) {
                                    return;
                                }
                                this.props.onChange({
                                    target: {
                                        name: "policyDiscussed",
                                        value: !this.props.getEmployeeValue("policyDiscussed", this.props.tabKey)
                                    }
                                }, this.props.tabKey);
                            }}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-6">
                        <Form.Group className="d-flex justify-content-end align-items-baseline">
                            <Form.Label className="col-6 text-right mr-2">
                                Mi. Hourly Rate
                            </Form.Label>
                            <Form.Control
                                type="number"
                                readOnly={!isEditable}
                                className="col-6"
                                name="minHourlyRate"
                                value={this.props.getEmployeeValue("minHourlyRate", this.props.tabKey) || 0}
                                onChange={(ev) => this.props.onChange(ev, this.props.tabKey)}
                            />
                        </Form.Group>
                    </div>
                </div>
                <div className="row">
                    <div className="col-6">
                        <Form.Group className="d-flex justify-content-end align-items-baseline">
                            <Form.Label className="col-6 text-right mr-2">
                                SIN
                            </Form.Label>
                            <Form.Control
                                type="number"
                                readOnly={!isEditable}
                                className="col-6"
                                name="sin"
                                value={this.props.getEmployeeValue("sin", this.props.tabKey) || ""}
                                onChange={(ev) => this.props.onChange(ev, this.props.tabKey)}
                            />
                        </Form.Group>
                    </div>
                    {this.props.workerId ?
                    <div className="col-6 text-right">
                        <button
                            className="btn btn-primary px-5"
                            onClick={this.handleResetPassword}
                        >
                            Reset password
                        </button>
                    </div>
                    : null}
                </div>

                <div className="row">
                    <div className="col-6">
                        <table className="table table-sm table-hover table-bordered">
                            <thead>
                            <tr>
                                <td colSpan={2} className="bg-primary text-light text-center">
                                    Applied For
                                </td>
                            </tr>
                            <tr>
                                <th>Position</th>
                                <th/>
                            </tr>
                            </thead>
                            <tbody>
                            {appliedFor.map(item => (
                                <tr key={item.id}>
                                    <td>{item.value}</td>
                                    <td>
                                        <input
                                            type="checkbox"
                                            className="form-control"
                                            checked={!!positionsApplied.find(
                                                currentPositionsApplied =>
                                                    currentPositionsApplied.id === item.id
                                            )}
                                            onChange={() => {
                                                if (!isEditable) {
                                                    return;
                                                }
                                                this.props.onChange({
                                                    target: {
                                                        name: "positionsApplied",
                                                        value: {
                                                            id: item.id,
                                                            value: item.value
                                                        }
                                                    }
                                                }, this.props.tabKey);
                                            }}
                                        />
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    </div>
                    <div className="col-6">
                        <table className="table table-sm table-hover table-bordered">
                            <thead>
                                <tr>
                                    <td colSpan={3} className="bg-primary text-light text-center">
                                        Languages
                                    </td>
                                </tr>
                                <tr>
                                    <th>Language</th>
                                    <th className="text-center">Spoken</th>
                                    <th className="text-center">Written</th>
                                </tr>
                            </thead>
                            <tbody>
                            {languages.map(language => (
                                <tr key={language.id}>
                                    <td>{language.value}</td>
                                    <td>
                                        <input
                                            type="checkbox"
                                            className="form-control"
                                            checked={this.getUserLanguage(language, true)}
                                            onChange={() => {
                                                if (!isEditable) {
                                                    return;
                                                }
                                                this.props.onChange({
                                                    target: {
                                                        name: "languages",
                                                        value: {
                                                            id: language.id,
                                                            name: language.value,
                                                            isSpoken: true,
                                                            value:
                                                        !this.getUserLanguage(language, true)
                                                        }
                                                    }
                                                }, this.props.tabKey);
                                            }}
                                        />
                                    </td>
                                    <td>
                                        <input
                                            type="checkbox"
                                            className="form-control"
                                            checked={this.getUserLanguage(language, false)}
                                            onChange={() => {
                                                if (!isEditable) {
                                                    return;
                                                }
                                                this.props.onChange({
                                                    target: {
                                                        name: "languages",
                                                        value: {
                                                            id: language.id,
                                                            name: language.value,
                                                            isSpoken: false,
                                                            value:
                                                        !this.getUserLanguage(language, false)
                                                        }
                                                    }
                                                }, this.props.tabKey);
                                            }}
                                        />
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );
    }
}

TabWorkerProfileInfo.defaultProps = {
    isEditable: false,
};

TabWorkerProfileInfo.propTypes = {
    workerId: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]).isRequired,
    tabKey: PropTypes.string.isRequired,
    getEmployeeValue: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    isEditable: PropTypes.bool
};

const mapStateToProps = state => ({
    employmentTypes: state.systemList.employmentTypes,
    employmentStatus: state.systemList.employmentStatus,
    languages: state.systemList.languages,
    appliedFor: state.systemList.appliedFor,
    workHoursAvailability: state.systemList.workHoursAvailability,
});

const mapStateToDispatch = dispatch => ({
    openCustomModal: bindActionCreators(openCustomModal, dispatch),
    closeCustomModal: bindActionCreators(closeCustomModal, dispatch),

    getEmploymentTypeItems: bindActionCreators(getEmploymentTypeItems, dispatch),
    getEmploymentStatusItems: bindActionCreators(getEmploymentStatusItems, dispatch),
    getLanguagesItems: bindActionCreators(getLanguagesItems, dispatch),
    getAppliedFor: bindActionCreators(getAppliedFor, dispatch),
    getHoursOfWorkAvailability: bindActionCreators(getHoursOfWorkAvailability, dispatch),

    resetPassword: bindActionCreators(resetPassword, dispatch),
});

export default connect(
    mapStateToProps,
    mapStateToDispatch
)(TabWorkerProfileInfo);
